import type { CommonEditorTab } from "./reducers";
import { mdiVectorCombine } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { NavbarTabButton } from "../shell/NavbarTabButton";

type Props = {
  disabled?: boolean;
};

export function NavbarRegionsTabButton({ disabled }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabButton
      tooltip={t("NavbarRegionsTabButton.tooltip")}
      value={"regions" satisfies CommonEditorTab}
      iconPath={mdiVectorCombine}
      disabled={disabled}
    />
  );
}
